import React from "react";

import classNames from "classnames";
import { Link } from "react-router-dom";

import styles from "./Button.module.css";
import Loader from "./Loader";

interface ButtonProps {
  href?: string;
  onClick?: () => void;
  className?: string;
  type?: "button" | "submit" | "reset";
  design?: "white" | "outline" | "outline-blue" | "";
  fontSize?: string;
  disabled?: boolean;
  loading?: boolean;
  children: React.ReactNode;
  name?: string;
  autoWidth?: boolean;
}

const Button = ({
  href = "",
  onClick = () => {},
  className = "",
  type = "button",
  name = "",
  design = "",
  fontSize = "base",
  disabled = false,
  loading = false,
  autoWidth = false,
  children,
}: ButtonProps) => {
  const getClassNames = (): string => {
    let classes = className || "";

    if (design === "white") {
      classes +=
        " text-center bg-white text-blue px-6 py-3 rounded-[5px] inline-block hover:bg-blue-hover hover:text-white transition-colors";
    } else if (design === "outline") {
      classes +=
        " text-center bg-blue text-white px-6 py-3 border-2 border-white rounded-[5px] inline-block hover:bg-white hover:text-blue-hover transition-colors";
    } else if (design === "outline-blue") {
      classes +=
        " text-center bg-white text-blue px-6 py-3 border-2 border-blue rounded-[5px] inline-block hover:border-blue-hover hover:text-blue-hover transition-colors";
    } else {
      classes +=
        " border-2 border-blue text-center bg-blue text-white px-6 py-3 rounded-[5px] inline-block hover:bg-blue-hover hover:border-blue-hover transition-colors";
    }

    if (disabled) {
      classes += " opacity-50 cursor-not-allowed";
    }

    // Add default styles
    classes += ` text-${fontSize} uppercase ${
      autoWidth ? "min-w-fit" : " min-w-[250px]"
    }`;
    return classes;
  };

  const handleClick = () => {
    if (loading || disabled) return;
    onClick();
  };

  const classes = getClassNames();

  if (href.length > 0) {
    return (
      <Link to={href} className={classes} onClick={handleClick}>
        <div className={classNames("min-w-fit", styles.inner)}>
          {children}
          {loading && <Loader />}
        </div>
      </Link>
    );
  }

  return (
    <button
      className={classes}
      disabled={disabled}
      type={!loading ? type : "button"}
      onClick={handleClick}
      name={name}
    >
      <div className={classNames("min-w-fit", styles.inner)}>
        {children}
        {loading && <Loader />}
      </div>
    </button>
  );
};

export default Button;
